import { Grid as BaseGrid, styled } from '@mui/material'

export const Column = styled(BaseGrid)`
  &.MuiGrid-root {
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0 5px'};
  }
`

export const Navigation = styled('section')`
  width: 100%;
`

export const Root = styled('div')`
  padding: 10px 0 0;
  width: ${props => props.width};
`
